/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".customPadding[_ngcontent-%COMP%]{padding:.5rem .5rem .5rem 1rem}"];
export { styles as styles };
